import { useState } from 'react';
import NestedEggCanvas from './NestedEggCanvas';
import ListViewFormat from './ListViewFormat';
import ReportViewFormat from './ReportViewFormat';

const SUB_VIEWS = [
  { key: 'egg', label: 'Nested Egg' },
  { key: 'list', label: 'List' },
  { key: 'report', label: 'Report' },
];

export default function DeliverableView({ mapName, measurement, tiles, clientName, updatedAt, onSwitchToBuild, mapId, buildScale }) {
  const [subView, setSubView] = useState('egg');

  function formatDate(d) {
    if (!d) return '';
    return new Date(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  return (
    <div className="h-full flex flex-col bg-canvas relative">
      {/* Sub-view toggle */}
      <div className="flex-shrink-0 bg-white border-b border-black/10 px-5 py-2 flex items-center justify-center gap-1" data-no-print>
        {SUB_VIEWS.map((v) => (
          <button
            key={v.key}
            onClick={() => setSubView(v.key)}
            className={`text-xs font-heading font-bold uppercase tracking-wider px-3 py-1.5 rounded-md transition-all ${
              subView === v.key
                ? 'bg-navy text-white'
                : 'text-txt-secondary hover:text-navy hover:bg-navy/5'
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>

      {/* Render the selected sub-view */}
      {subView === 'egg' && <NestedEggCanvas tiles={tiles} mapName={mapName} measurement={measurement} initialScale={buildScale} />}
      {subView === 'list' && <ListViewFormat tiles={tiles} mapName={mapName} measurement={measurement} />}
      {subView === 'report' && <ReportViewFormat tiles={tiles} mapName={mapName} measurement={measurement} clientName={clientName} updatedAt={updatedAt} mapId={mapId} />}

      {/* Footer pinned to bottom */}
      <div className="flex-shrink-0 px-8 py-2 flex flex-col items-center gap-1 bg-gradient-to-t from-canvas to-transparent" data-no-print>
        {onSwitchToBuild && (
          <p className="text-xs text-txt-secondary/60 italic">
            Switch to{' '}
            <button
              onClick={onSwitchToBuild}
              className="font-semibold not-italic underline hover:text-txt-primary transition-colors"
            >
              Build
            </button>{' '}
            to edit your map
          </p>
        )}
        <div className="w-full flex items-center justify-between text-xs text-txt-secondary/50 uppercase">
          <span>{clientName} {updatedAt ? `· ${formatDate(updatedAt)}` : ''}</span>
          <span>The Clarity Map · Brain-Centric Design</span>
        </div>
      </div>
    </div>
  );
}
